import { PanelConfig, PanelId } from '../../core/types/panel.types';

export const DEFAULT_PANEL_CONFIGS: Record<PanelId, PanelConfig> = {
  'hierarchy': {
    id: 'hierarchy',
    title: 'Hierarchy',
    icon: 'List',
    position: 'left',
    state: 'normal',
    visible: true,
    order: 0,
    minWidth: 200,
    minHeight: 200,
    defaultWidth: 250,
    defaultHeight: 400,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'scene-view': {
    id: 'scene-view',
    title: 'Scene View',
    icon: 'Layout',
    position: 'center',
    state: 'normal',
    visible: true,
    order: 0,
    minWidth: 400,
    minHeight: 300,
    defaultWidth: 800,
    defaultHeight: 600,
    closeable: false,
    minimizable: false,
    maximizable: true,
  },
  'inspector': {
    id: 'inspector',
    title: 'Inspector',
    icon: 'Settings',
    position: 'right',
    state: 'normal',
    visible: true,
    order: 0,
    minWidth: 250,
    minHeight: 200,
    defaultWidth: 300,
    defaultHeight: 400,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'project': {
    id: 'project',
    title: 'Project',
    icon: 'Folder',
    position: 'bottom',
    state: 'normal',
    visible: true,
    order: 0,
    minWidth: 400,
    minHeight: 150,
    defaultWidth: 800,
    defaultHeight: 200,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'script-editor': {
    id: 'script-editor',
    title: 'Script Editor',
    icon: 'Code',
    position: 'center',
    state: 'normal',
    visible: false,
    order: 1,
    minWidth: 400,
    minHeight: 300,
    defaultWidth: 800,
    defaultHeight: 600,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'animation-editor': {
    id: 'animation-editor',
    title: 'Animation Editor',
    icon: 'Film',
    position: 'bottom',
    state: 'normal',
    visible: false,
    order: 1,
    minWidth: 500,
    minHeight: 200,
    defaultWidth: 800,
    defaultHeight: 250,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'live-preview': {
    id: 'live-preview',
    title: 'Live Preview',
    icon: 'Play',
    position: 'center',
    state: 'normal',
    visible: false,
    order: 2,
    minWidth: 320,
    minHeight: 240,
    defaultWidth: 640,
    defaultHeight: 480,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'console': {
    id: 'console',
    title: 'Console',
    icon: 'Terminal',
    position: 'bottom',
    state: 'normal',
    visible: false,
    order: 2,
    minWidth: 400,
    minHeight: 100,
    defaultWidth: 800,
    defaultHeight: 150,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'slot-asset-generator': {
    id: 'slot-asset-generator',
    title: 'Slot Asset Generator',
    icon: 'Gamepad2',
    position: 'floating',
    state: 'floating',
    visible: false,
    order: 3,
    minWidth: 900,
    minHeight: 600,
    defaultWidth: 1100,
    defaultHeight: 750,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
  'slot-screen-generator': {
    id: 'slot-screen-generator',
    title: 'Slot Screen Generator',
    icon: 'Monitor',
    position: 'floating',
    state: 'floating',
    visible: false,
    order: 4,
    minWidth: 1000,
    minHeight: 700,
    defaultWidth: 1400,
    defaultHeight: 900,
    closeable: true,
    minimizable: true,
    maximizable: true,
  },
};

export const PANEL_ORDER: PanelId[] = [
  'hierarchy',
  'scene-view',
  'inspector',
  'project',
  'script-editor',
  'animation-editor',
  'live-preview',
  'console',
  'slot-asset-generator',
  'slot-screen-generator',
];
